import { api } from "../../services/NetworkBase";

export async function GetTestKits() {
    try {
        let response = await api
            .get(`vlp/test-kits`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function UpdateTestKit(kit) {
    try {
      let response = await api.put("vlp/test-kits", { json: kit });
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  export async function SaveTestKit(kit) {
    try {
      let response = await api.post("vlp/test-kits", {
        json: kit,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  export async function DeleteTestKit(testKitId) {
    try {
      const encodedUrl = encodeURIComponent(testKitId);
      let response = await api
        .delete(`vlp/test-kits/${encodedUrl}`)
        .json();
      return response;
    } catch (error) {
      throw error;
    }
  }